import requestAction from '../utils/requestAction'
import { pushAlert } from './alert'

export const notifySchools = requestAction('NOTIFY_SCHOOLS')(
  `assignations/notify-schools`, 'POST', undefined,
  (dispatch) => dispatch(pushAlert("Escuelas notificadas"))
)
